import React from "react";
import { SeoAnalysisReport } from "../seoAnalyzer";
import { Gauge, FileText, Network, Image as ImageIcon, Database, FileCheck } from "lucide-react";

interface MetricsQuickBarProps {
  metrics: SeoAnalysisReport["metrics"];
}

export const MetricsQuickBar: React.FC<MetricsQuickBarProps> = ({ metrics }) => {
  const sizeKb = (metrics.contentLengthBytes / 1024).toFixed(1);

  const items = [
    {
      label: "TTFB Latency",
      value: `${metrics.ttfbMs} ms`,
      icon: <Gauge size={18} />,
      status: metrics.ttfbMs < 300 ? "good" : metrics.ttfbMs < 800 ? "warn" : "bad",
    },
    {
      label: "HTML Payload",
      value: `${sizeKb} KB`,
      icon: <FileText size={18} />,
      status: "info",
    },
    {
      label: "DOM Nodes",
      value: `${metrics.domNodesCount}`,
      icon: <Network size={18} />,
      status: metrics.domNodesCount < 1500 ? "good" : "warn",
    },
    {
      label: "Images Audited",
      value: `${metrics.totalImages - metrics.missingAltImagesCount} / ${metrics.totalImages} Alt`,
      icon: <ImageIcon size={18} />,
      status: metrics.missingAltImagesCount === 0 ? "good" : "warn",
    },
    {
      label: "JSON-LD Schemas",
      value: metrics.jsonLdTypes.length > 0 ? `${metrics.jsonLdTypes.length} Detected` : "None",
      icon: <Database size={18} />,
      status: metrics.jsonLdTypes.length > 0 ? "good" : "warn",
    },
    {
      label: "Robots & Sitemap",
      value: `${metrics.robotsTxtStatus === "found" ? "Robots ✓" : "Robots ✗"} | ${metrics.sitemapStatus === "found" ? "Sitemap ✓" : "Sitemap ✗"}`,
      icon: <FileCheck size={18} />,
      status: metrics.robotsTxtStatus === "found" && metrics.sitemapStatus === "found" ? "good" : "warn",
    },
  ];

  return (
    <div className="metrics-row">
      {items.map((item, idx) => (
        <div key={idx} className="metric-pill">
          <div
            className="metric-icon-wrap"
            style={{
              color:
                item.status === "good"
                  ? "var(--neon-emerald)"
                  : item.status === "warn"
                  ? "var(--neon-amber)"
                  : item.status === "bad"
                  ? "var(--neon-crimson)"
                  : "var(--neon-cyan)",
            }}
          >
            {item.icon}
          </div>
          <div className="metric-info">
            <span className="metric-val">{item.value}</span>
            <span className="metric-lbl">{item.label}</span>
          </div>
        </div>
      ))}
    </div>
  );
};
